module.exports = __webpack_public_path__ + "static/media/ico-react.6f9fc2b9.svg";